export const createDropzoneFileName = fileType => {
  const sliceIndex = fileType.indexOf('/');
  return fileType.slice(0, sliceIndex);
};
